module.exports = __webpack_public_path__ + "static/media/32.a7715e42.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/32.png
// module id = 886
// module chunks = 0